import { useDropzone } from "react-dropzone";
import { FaCloudUploadAlt, FaFilePdf } from "react-icons/fa";
import axios from "axios";
import { useLocation , useNavigate } from "react-router-dom";
import React, { useEffect, useState, useCallback } from "react";
import moment from "moment-timezone";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

function TerminationDetail() {
    const navigate = useNavigate();
    const [terminationDetail, setTerminationDetail] = useState({ terminationItemlist: [] ,  terminationFeedbackList: []});

    const resource = "upload-termination-installation";
    const storedToken = localStorage.getItem("token");
    const [uploading, setUploading] = useState(false);
    const [loggedEmail, setloggedEmail] = useState("");
    const [openConfirmUpload, setOpenConfirmUpload] = useState(false);
    const [openUploadSuccess, setOpenUploadSuccess] = useState(false);
    const [openUploadFail, setOpenUploadFail] = useState(false);
    const [installationNote, setInstallationNote] = useState('');

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    
    useEffect(() => {
        const checkSessionToken = async () => {
          try {
            const response = await fetch(
              `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  authorization: "Basic eGNwOk50dGkyMDI0IQ==",
                },
              }
            );
    
            if (!response.ok) {
              setError(data.message || "Failed to fetch session token data");
              throw new Error(data.message || "Failed to fetch session token data");
            }
    
            // Parse response text as a boolean value
            const text = await response.text();
            const data = text === "true";
    
            if (data) {
            } else {
              window.alert("Session is invalid");
              navigate("/login");
            }
          } catch (error) {
            console.error("Fetch Error:", error.message);
            setError("Fetch Error: " + error.message);
          }
        };
    
        checkSessionToken();
      }, []);  

      useEffect(() => {
          // Retrieve the token from local storage
          const storedToken = localStorage.getItem("token");
          // setToken(storedToken);
      
          // Fetch internal data using the token
          const fetchInternalData = async () => {
            try {
              const response = await fetch(
                `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/find-by-token?token=${storedToken}`,
                {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json",
                    authorization: "Basic eGNwOk50dGkyMDI0IQ==",
                  },
                }
              );
      
              const data = await response.json();
              if (!response.ok) {
                setError(data.message || "Failed to fetch internal data");
                throw new Error(data.message || "Failed to fetch internal data");
              }
      
              setloggedEmail(data[0].xcp_internal_email);
            } catch (error) {
              console.error("Fetch Error:", error.message);
              setError("Fetch Error: " + error.message);
            }
          };
      
          fetchInternalData();
        }, []);

      useEffect(() => {
              loadTerminationDetail(searchParams.get('param1'));
            },  []);

      const loadTerminationDetail = async (terminationId) => {
        try {       
        const result = await axios.get(`https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/termination/termination-detail?terminationId=${terminationId}`, {
              headers: {
                authorization: 'Basic eGNwOk50dGkyMDI0IQ==',
              },
            });
        const data = result.data;

            setTerminationDetail(data);
        } catch (error) {
        console.error("Error loading termination list:", error);
        }
    };

    const formatDate = (datetime) => {
        const date = new Date(datetime);
        const year = date.getUTCFullYear(); // Gunakan UTC
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Gunakan UTC
        const day = String(date.getUTCDate()).padStart(2, '0'); // Gunakan UTC
        return `${day}/${month}/${year}`;
      };
    
      const [file, setFile] = useState(null);
      const [error, setError] = useState(null);
    
      const fileTypes = ["application/pdf"];
      const maxSize = 10 * 1024 * 1024; // 10MB
    
      const onDrop = useCallback((acceptedFiles) => {
        const selectedFile = acceptedFiles[0];
        setError(null); // Clear previous error
    
        // Validate file type
        if (!fileTypes.includes(selectedFile.type)) {
          setError("Invalid file type, upload a PDF format");
          setFile(null);
          return;
        }
    
        // Validate file size
        if (selectedFile.size > maxSize) {
          setError("File size exceeds 10MB, please upload file size below 10MB");
          return;
        }
    
        if (!selectedFile) {
          setError("No file selected");
          return;
        }
    
        setFile(selectedFile);
      }, []);

      const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: fileTypes.join(","),
        multiple: false,
      });

      const handleClose = () => {
        setOpenConfirmUpload(false);
        setOpenUploadFail(false)
      };
    
      const handleConfirmation = async (event) => {
        event.preventDefault();
        setOpenConfirmUpload(true);
      };

        const terminationId = searchParams.get("param1");
    
      const handleUpload = async (e) => {
        // e.preventDefault();
        if (!file) {
          setOpenConfirmUpload(false);
          setError("Please upload one a valid file");
          return;
        }
    
        if (file && !isValidFileName(file.name)) {
          setOpenConfirmUpload(false);
          // Handle invalid file name
          setError(
            "File name contains special characters. Please use only letters or numbers"
          );
          return;
        }
    
        // Perform further actions like uploading the file to the server
    
        setUploading(true);
        try {
          // Step 1: Get the presigned URL from the backend   
          const response = await axios.get(
            `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/termination/upload-installation?terminationId=${terminationId}&fileName=${file.name}`, {
              headers: {
                authorization: 'Basic eGNwOk50dGkyMDI0IQ==',
              },
            }
          );
    
          if (response.status === 200) {
            const uploadUrl = response.data.uploadUrl;
    
            // Step 2: Upload the file to S3 using the presigned URL
            const responseUploadS3 = await axios.put(uploadUrl, file, {
              headers: {
                "Content-Type": file.type,
              },
            });
    
            if (responseUploadS3.status === 200) {
              const createdDate = getCreatedDate();

              const formData = {
                terminationId: terminationId,
                loggedEmail: loggedEmail,
                currentTerminationStatus: terminationDetail.xcp_termination_status,
                fileName: file.name,
                createdDate: createdDate,
                installationNote: installationNote
              };
    
              try {
                const response = await fetch(
                  "https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/termination/update-termination-status",
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      authorization: "Basic eGNwOk50dGkyMDI0IQ==",
                    },
                    body: JSON.stringify(formData),
                  }
                );
    
                const data = await response.json();
                const responseBody = JSON.parse(data.body);
                if (!response.ok) {
                  setError(data.message || "Failed to update status");
                  throw new Error(data.message || "Failed to update status");
                }
    
                const { message } = responseBody;
                if (message == "success") {
                  setOpenConfirmUpload(false)
                  setOpenUploadSuccess(true)
                } else {
                  setOpenConfirmUpload(false)
                  setOpenUploadFail(true)
                }
              } catch (error) {
                console.error("Submission Error:", error.message);
                setError("Submission Error: " + error.message);
              }
            } else {
              setError("File upload failed");
            }
          } else {
            setError("File upload failed: " + response.message);
          }
        } catch (err) {
          setError("File upload failed");
          console.error("File upload failed", err);
        } finally {
          setUploading(false);
        }
      };

       function getCreatedDate() {
          const currentDate = new Date().toISOString().split("T")[0];
      
          const userTimeZone = moment.tz.guess();
          // Get the current time in the user's local time zone
          const currentTime = moment.tz(userTimeZone).format("HH:mm:ss");
          // Combine the selected date with the current time
          const dateTimeInUserTimeZone = moment
            .tz(`${currentDate}T${currentTime}`, userTimeZone)
            .format("YYYY-MM-DDTHH:mm:ss"); 
          return dateTimeInUserTimeZone;
        }

      
      function isValidFileName(fileName) {
        // Regular expression to match special characters (excluding spaces and alphanumeric characters)
        const regex = /^[a-zA-Z0-9 ._-]+$/;
        return regex.test(fileName);
      }
    
      function uploadSuccess(){
        navigate("/termination-list")
      }
      
    return (
        <div className='container-order-input'>
          <Dialog open={openConfirmUpload}>
          <DialogTitle>{"Are you sure you want to upload this installation?"}</DialogTitle>
              <DialogContent>
                  <DialogContentText>
                      Clicking "Yes" will upload this installation.
                  </DialogContentText>
              </DialogContent>
          <DialogActions>
              <Button onClick={handleClose} color="primary">
                  No
              </Button>
              <Button onClick={handleUpload} color="primary" autoFocus>
                  Yes
              </Button>
          </DialogActions>
        </Dialog> 
        <Dialog open={openUploadSuccess}>
          <DialogTitle>{"File uploaded successfully!"}</DialogTitle>
          <DialogActions>
            <Button onClick={uploadSuccess} color="primary" autoFocus>
              Ok
            </Button>
          </DialogActions>
      </Dialog>
      <Dialog open={openUploadFail}>
        <DialogTitle>{"Upload File Failed"}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
            <h1 className='main-title'>Cross Connect Upload Termination Installation</h1> 
            <div className="order-information-order-input">
                <div className='title-order-input'>                            
                    <h5>Termination Information</h5>  
                </div>                      
                <div className="textbox-gray">
                        <label htmlFor="terminationDate">Termination Date</label>
                        <input type="text" placeholder={formatDate(terminationDetail.termination_date)} disabled/>
                    </div>
                    <div className="textbox-gray">
                        <label htmlFor="terminationPic">Termination PIC</label>
                        <input type="text" placeholder={terminationDetail.termination_pic} disabled/>
                    </div>
            </div>

    {terminationDetail.terminationItemlist && terminationDetail.terminationItemlist.length > 0 && terminationDetail.terminationItemlist.map((termination, index) => (
    <div>
        <div className="title-order-input">
            <h5>Termination Item ({index + 1})</h5>
        </div>  
        <div className='box-two-part'>                 
            <div className="requestor-information">                           
                    <div className="textbox-gray">
                        <label htmlFor="companyName">Cable Id</label>
                        <input type="text" placeholder={termination.cable_id} disabled/>
                    </div>
                    <div className="textbox-gray">
                        <label htmlFor="picName">Company Name Requestor</label>
                        <input type="text" placeholder={termination.company_requestor} disabled/>
                    </div>
                    <div className="textbox-gray">
                        <label htmlFor="contactEmail">PIC Name Requestor</label>
                        <input type="text" placeholder={termination.pic_requestor} disabled/>
                    </div>
                    <div className="textbox-gray">
                        <label htmlFor="orderDate">Order Date</label>
                        <input type="text" placeholder={formatDate(termination.order_date)} disabled/>
                    </div>
                    <div className="textbox-gray">
                        <label htmlFor="comboBox" className='requestLocation'>Request Location</label>
                        <select id="comboBox" name="options" disabled>
                        <option value="option1">{termination.order_location_name}</option>
                        </select>
                    </div>       
                    <div className="radio-button">
                        <label>Cross Connect Type</label>
                        <div className="radio-button-option">
                            <input type="radio" name={`connect-${index}`} id="connect-one" 
                            checked={termination.order_type_id === 1} 
                            disabled/>
                            <label htmlFor={`connect-one-${index}`}>Interconnection to other tenant device</label>
                        </div>
                        <div className="radio-button-option">
                            <input type="radio" name={`connect-${index}`} id="connect-two" 
                            checked={termination.order_type_id === 2}
                            disabled/>
                            <label htmlFor={`connect-two-${index}`}>Interconnection to your own device</label>
                        </div>
                    </div>         
            </div>

            <div className="destination-information">        
                    <div className="textbox-gray">
                        <label htmlFor="cableStatus">Cable Status</label>
                        <input type="text" placeholder={termination.cable_status} disabled/>
                    </div>
                    <div className="textbox-gray">
                        <label htmlFor="companyNameDestination">Company Name Destination</label>
                        <input type="text" placeholder={termination.company_destination} disabled/>
                    </div>       
                    <div className="textbox-gray">
                        <label htmlFor="picNameDestination">PIC Name Destination</label>
                        <input type="text" placeholder={termination.pic_destination} disabled/>
                    </div> 
                    <div className="textbox-gray">
                        <label htmlFor="installationDate">Installation Date</label>
                        <input type="text" placeholder={formatDate(termination.installation_date)} disabled/>
                    </div>
                        
                    <div className="textbox-gray">
                        <label htmlFor="salesOrderNumber">Sales Order Number</label>
                        <input type="text" placeholder={termination.sales_order_no} disabled/>
                    </div>                          
            </div>                
        </div>
        
         <div className='box-two-part'>          
            <div className="a-end-information">
                <div className="title-box-order-input">
                    <h5>A-end Information</h5>
                </div>         
                <div className="textbox-gray">
                    <label htmlFor="comboBox">Cable Type</label>
                    <select id="comboBox" name="options" disabled>
                        <option value="option1">{termination.cable_type_a}</option>  
                    </select>
                    </div>
                    <div className="textbox-gray">
                    <label htmlFor="comboBox">Interface</label>
                    <select id="comboBox" name="options" disabled>
                        <option value="option1">{termination.interface_name_a}</option>  
                    </select>
                    </div>
                    <div className="textbox-gray">
                    <label htmlFor="comboBox">Floor</label>
                    <select id="comboBox" name="options" disabled>
                        <option value="option1">{termination.floor_name_a}</option>  
                    </select>
                    </div>
                    <div className="textbox-gray">
                    <label htmlFor="comboBox">Room</label>
                    <select id="comboBox" name="options" disabled>
                        <option value="option1">{termination.room_name_a}</option>  
                    </select>
                    </div>   
                    <div className="textbox-gray">
                        <label htmlFor="rackId">Rack ID</label>
                        <input type="text" placeholder={termination.a_end_rack_id} disabled/>
                    </div>
                    <div className="textbox-gray">
                        <label htmlFor="cableQuantity">Cable Quantity</label>
                        <input type="text" placeholder={termination.cable_quantity} disabled/>
                    </div>
            </div>

            <div className="b-end-information">
                <div className="title-box-order-input">
                    <h5>B-end Information</h5>
                </div>         
                <div className="textbox-gray">
                    <label htmlFor="comboBox">Cable Type</label>
                    <select id="comboBox" name="options" disabled>  
                        <option value="option1">{termination.cable_type_b}</option>              
                    </select>
                    </div>
                    <div className="textbox-gray">
                    <label htmlFor="comboBox">Interface</label>
                    <select id="comboBox" name="options" disabled>
                        <option value="option1">{termination.interface_name_b}</option>
                    </select>
                    </div>
                    <div className="textbox-gray">
                    <label htmlFor="comboBox">Floor</label>
                    <select id="comboBox" name="options" disabled>
                        <option value="option1">{termination.floor_name_b}</option>
                    </select>
                    </div>
                    <div className="textbox-gray">
                    <label htmlFor="comboBox">Room</label>
                    <select id="comboBox" name="options" disabled>
                        <option value="option1">{termination.room_name_b}</option>                      
                    </select>  
                    </div>               
                    <div className="textbox-gray">
                        <label htmlFor="rackId">Rack ID</label>
                        <input type="text" placeholder={termination.b_end_rack_id} disabled/>
                    </div>                 
            </div>    
        </div>
    </div>
    ))}  
 
        <div className='box-two-part'>      
            <div className='feedback-history'>
                <h5>Termination Feedback History</h5>
                <table class="table table-bordered">
                       <thead>
                            <tr>
                            <th scope="col">User</th>
                            <th scope="col">User</th>
                            <th scope="col" className="note-column">Note</th>
                            </tr>
                        </thead>
                        <tbody>                        
                        {terminationDetail.terminationFeedbackList.map((termination) => (
                            <tr>
                                <td>{formatDate(termination.feedback_date)}</td>
                                <td>{termination.username}</td>
                                <td className="note-column">{termination.feedback}</td>
                            </tr>
                           ))}   
                        </tbody>
                    </table> 
                </div>               
            </div>
            
            <div className="box-two-part">
                    <h5>Upload Installation</h5>
                    <form onSubmit={handleConfirmation}>
                     
                      <div {...getRootProps()} className="dropzone">
                        <input {...getInputProps()} />
                        <FaCloudUploadAlt size={50} color="#007bff" />
                        <p>
                          Drag and drop a PDF file (max 10MB) here, or click to select one
                        </p>
                      </div>
                      {file && (
                        <div className="file-info">
                          <FaFilePdf size={40} color="#f40" />
                          <p>{file.name}</p>
                        </div>
                      )}
                      <div className="upload-installation"> 
                        <div className="textbox">
                          <label htmlFor="Note">Installation Note</label>
                          <textarea
                          value={installationNote} 
                          onChange={(e) => setInstallationNote(e.target.value)}
                          placeholder='Installation Note'       
                          ></textarea>  
                        </div>
                      </div>
                      {error && <p className="error-message">{error}</p>}
                      <button type="submit" className="upload-button" disabled={uploading}>
                        {uploading ? "Uploading..." : "Upload"}
                      </button>        
                    </form>
                  </div> 
        </div>
    );
}

export default TerminationDetail;
